import CloseIcon from "@/components/_icons/closeIcon";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { useTranslations } from "next-intl";
export interface ScanToOrderCartHeaderProps {
  onRequestClose: () => void;
}

export const ScanToOrderCartHeader = ({
  onRequestClose,
}: ScanToOrderCartHeaderProps) => {
  const t = useTranslations("ScanToOrderCartHeader");
  return (
    <div
      data-testid={applyDataTestId(pom.scanToOrder.scanToOrderCartHeader)}
      className="min-h-14 justify-between px-4 flex shadow-md"
    >
      <p className="text-xl font-medium pt-[15px]">{t("yourCart")}</p>
      <button onClick={onRequestClose}>
        <CloseIcon />
      </button>
    </div>
  );
};
